/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Jobs_Submitted_SuccessfullyInputs */



/**
* | output |
* | --- |
* | "Jobs submitted successfully" |
*
* @param {Jobs_Submitted_SuccessfullyInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const jobs_submitted_successfully = /** @type {((inputs?: Jobs_Submitted_SuccessfullyInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Jobs_Submitted_SuccessfullyInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Tâches soumises avec succès")
	if (locale === "de") return /** @type {LocalizedString} */ ("Jobs erfolgreich eingereicht")
	if (locale === "it") return /** @type {LocalizedString} */ ("Lavori inviati con successo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Заявки успешно отправлены.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Trabajos enviados exitosamente")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("已成功提交职位")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ジョブが正常に送信されました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कार्य सफलतापूर्वक सबमिट हो गए")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Trabalhos submetidos com sucesso")
	return /** @type {LocalizedString} */ ("Jobs submitted successfully")
});